/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIUnreadEntity } from './APIUnreadEntity';
import {
    APIUnreadEntityFromJSON,
    APIUnreadEntityFromJSONTyped,
    APIUnreadEntityToJSON,
} from './APIUnreadEntity';

/**
 * 
 * @export
 * @interface APIUnreadOverview
 */
export interface APIUnreadOverview {
    /**
     * 
     * @type {APIUnreadEntity}
     * @memberof APIUnreadOverview
     */
    guestRequests: APIUnreadEntity;
    /**
     * 
     * @type {APIUnreadEntity}
     * @memberof APIUnreadOverview
     */
    requests: APIUnreadEntity;
    /**
     * 
     * @type {APIUnreadEntity}
     * @memberof APIUnreadOverview
     */
    offers: APIUnreadEntity;
    /**
     * 
     * @type {APIUnreadEntity}
     * @memberof APIUnreadOverview
     */
    contracts: APIUnreadEntity;
    /**
     * 
     * @type {APIUnreadEntity}
     * @memberof APIUnreadOverview
     */
    bills: APIUnreadEntity;
    /**
     * 
     * @type {number}
     * @memberof APIUnreadOverview
     */
    total: number;
}

/**
 * Check if a given object implements the APIUnreadOverview interface.
 */
export function instanceOfAPIUnreadOverview(value: object): value is APIUnreadOverview {
    if (!('guestRequests' in value) || value['guestRequests'] === undefined) return false;
    if (!('requests' in value) || value['requests'] === undefined) return false;
    if (!('offers' in value) || value['offers'] === undefined) return false;
    if (!('contracts' in value) || value['contracts'] === undefined) return false;
    if (!('bills' in value) || value['bills'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function APIUnreadOverviewFromJSON(json: any): APIUnreadOverview {
    return APIUnreadOverviewFromJSONTyped(json, false);
}

export function APIUnreadOverviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIUnreadOverview {
    if (json == null) {
        return json;
    }
    return {
        
        'guestRequests': APIUnreadEntityFromJSON(json['guest_requests']),
        'requests': APIUnreadEntityFromJSON(json['requests']),
        'offers': APIUnreadEntityFromJSON(json['offers']),
        'contracts': APIUnreadEntityFromJSON(json['contracts']),
        'bills': APIUnreadEntityFromJSON(json['bills']),
        'total': json['total'],
    };
}

export function APIUnreadOverviewToJSON(value?: APIUnreadOverview | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'guest_requests': APIUnreadEntityToJSON(value['guestRequests']),
        'requests': APIUnreadEntityToJSON(value['requests']),
        'offers': APIUnreadEntityToJSON(value['offers']),
        'contracts': APIUnreadEntityToJSON(value['contracts']),
        'bills': APIUnreadEntityToJSON(value['bills']),
        'total': value['total'],
    };
}

